import { Checkbox, CheckboxProps } from 'antd'

export interface KBCheckboxProps extends CheckboxProps {}

export function KBCheckbox(props: KBCheckboxProps) {
  return <Checkbox {...props}></Checkbox>
}
KBCheckbox.Group = Checkbox.Group
